import { render, staticRenderFns } from "./UpdoxFooter.vue?vue&type=template&id=341173e8&scoped=true"
import script from "./UpdoxFooter.vue?vue&type=script&lang=js"
export * from "./UpdoxFooter.vue?vue&type=script&lang=js"
import style0 from "./UpdoxFooter.vue?vue&type=style&index=0&id=341173e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@7.0.0-bridge.0_@babel+core@7.28._1eb1b9dda9fe6d233009820956254809/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341173e8",
  null
  
)

export default component.exports